import { useAtom } from "jotai";
import { useSearchParams } from "next/navigation";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useFixedBottomSpacer } from "@/hooks/useFixedBottomSpacer";
import useSellingMode from "@/hooks/useSellingMode";
import { useTaxSettings } from "@/hooks/useTaxSettings";
import { Row } from "@/utils/bootstrap";
import { PagesPaths } from "@/utils/functions/pages-paths";
import Price from "../../../lib/Price";
import CartAuthSection from "./CartAuthSection";
import CartCheckoutSection from "./CartCheckoutSection";

interface Props {
  total: number;
  mobile?: boolean;
  tax?: number;
}

const CartButtons: React.FC<Props> = ({ total, tax, mobile = false }) => {
  const t = useTranslation();
  const taxSettings = useTaxSettings();
  useFixedBottomSpacer(mobile ? 140 : 0);
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isSignedIn] = useAtom(isSignedInAtom);
  const { enableCheckout } = useSellingMode();
  const checkoutPath = isSignedIn
    ? PagesPaths.userCheckout
    : PagesPaths.checkout;

  const goToAuthFromCart = () => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("fromCart", "true");
    return params.toString();
  };
  return (
    <div className="cart-btns w-100">
      {taxSettings.enabled && !!tax && (
        <div className="cart-tax">
          <div>{t[taxSettings.labelKey]}:</div>
          <Price price={{ value: tax! }} />
        </div>
      )}
      <div className="total">
        <h2 className="total-title m-0">{t.grand_total}</h2>
        <p className="hide-to-vistor">{t.total}</p>
        <Price price={{ value: total, className: "total-value" }} />
      </div>
      <Row className="m-0" style={{ gap: 12 }}>
        {enableCheckout ? (
          <CartCheckoutSection
            isMobile={mobile}
            onCheckOut={() => router.push(checkoutPath)}
            onContinueShopping={() => router.push("/")}
          />
        ) : (
          <CartAuthSection
            onRegister={() => {
              router.push(PagesPaths.register + "?" + goToAuthFromCart());
            }}
            onSignIn={() => {
              router.push(PagesPaths.signin + "?" + goToAuthFromCart());
            }}
          />
        )}
      </Row>
    </div>
  );
};

export default CartButtons;
